import { OAuthModuleConfig } from 'angular-oauth2-oidc';
import { environment } from '@env';

const ALLOWED_URLS = [environment.apiBaseUrl, environment.idpBaseUrl];
const PUBLIC_API_PATTERNS: RegExp[] = [
  /\/users\/[^/]+\/verification-email$/
];

export const authModuleConfig: OAuthModuleConfig = {
  resourceServer: {
    sendAccessToken: true,
    customUrlValidation: (url) => {
      if (PUBLIC_API_PATTERNS.some(pattern => pattern.test(url))) {
        return false;
      }

      return !!ALLOWED_URLS.find(u => url.toLowerCase().startsWith(u.toLowerCase()))
        || url.startsWith('/');
    }
  }
};
